import { apiCall } from "../helper/Common";

export async function fetchTemplates() {
  return apiCall("templates", "GET");
}

export async function fetchTemplate(id) {
  return apiCall(`templates/${id}`, "GET");
}

export async function createTemplate(payload) {
  return apiCall("templates", "POST", payload);
}

export async function updateTemplate(id, payload) {
  return apiCall(`templates/${id}`, "PUT", payload);
}

export async function deleteTemplate(id) {
  return apiCall(`templates/${id}`, "DELETE", null);
}
